<template>
  <div class="monitoringall">
    <el-dropdown trigger="click" @command="handleCommand" placement="top-start" >
      <span class="el-dropdown-link">
        <div class="tag">
          <img src="../../../assets/img/tag.png" alt="" />切换配电图
        </div>
      </span>
      <el-dropdown-menu slot="dropdown" >
        <div class="hodern">
          <el-tree  ref="tree" 
          :data="treeList" 
          default-expand-all 
          node-key="id"  
          @node-click="nodeClick" 
          :props="defaultProps">
            <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.label }}<img src="../../../assets/img/aright.png" class="imgshow" v-if="data.children.length>=1"></span>
            </span> -->
          </el-tree>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { chainIndex } from "../../../api/linkindex";
import MsgBus from "../../../util/bus";
export default {
  name: "monitoringall",
  props:{
    currentVideoIndex:Number
  },
  data() {
    return {
      IsShow: 0,
      itemTitle: "",
      felice: "",
      id: "",
      message: [],
      meUrl: "",
      textNo: "",
      treeList:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  mounted() {
    this.forEtem();
    this.getFloor();
    MsgBus.$on("currindex",(item) => { 
        this.$refs.tree.setCheckedKeys([item]);
        this.$refs.tree.setCurrentKey(item);
    });
  },
  watch: {
    felice(val) {
      this.felice = val;
      this.id = this.$store.state.project.currentProject.projectId;

      chainIndex.monitoring(this.id).then((res) => {
        this.message = res.data.data.result.filter(
          (array) => {
            if (array.areaName.match(this.felice) !== null) {
              return array;
            } else if (this.felice == "") {
              return this.message;
            }
          }
        );
      });
    },

    message(o, n) {
      if (this.message.length == 0) {
        this.IsShow = 1;
        this.textNo = "暂无数据";
      } else {
        this.IsShow = 0;
        this.textNo = "";
      }
    },
  },
  methods: {
    nodeClick(obj,obj2,obj3){
      if(obj.diagramDesc){
        this.$refs.tree.setCheckedKeys([obj.id]);
        this.$refs.tree.setCurrentKey(obj.id);
        this.itemTitle = obj.diagramDesc;
        this.meUrl = obj.uploadFileUrl;
        MsgBus.$emit('wrid', this.meUrl);
        // this.$emit("wrid", this.meUrl);
      }else{
        return
      }
      
    },
    objectOrder(obj) {//排序的函数
      var newkey = Object.keys(obj).sort(); //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
      var newObj = {};//创建一个新的对象，用于存放排好序的键值对
      for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
          newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
      }
      return newObj;//返回排好序的新对象
    },
    getFloor(){
      this.id = this.$store.state.project.currentProject.projectId;
      chainIndex.floor(this.id).then((res) => {
        let list = res.data.data.result;
        for (var i in this.objectOrder(list)) {
          if(i!="无楼层"){
            if(list[i][0].wirings.length>0){
              let data = list[i][0].wirings.filter((l,o) => {l.label = l.diagramDesc;l.id=o; l.children=[];return l})
              this.treeList.push({
                label:i,
                // id: list[i][0].id,
                children:data
              })
            }else{
              this.treeList.push({
                label:i,
                children:[]
              })
            }
          }else{
              let data = list[i][0].wirings.filter((l,o) => {l.label = l.diagramDesc;l.id=o; l.children=[];return l})
              this.treeList = data
          } 
          
        }
      })
    },
    forEtem() {
      this.id = this.$store.state.project.currentProject.projectId;
      chainIndex.monitoring(this.id).then((res) => {
        this.message = res.data.data.result;
    //  this.message=this.message.map(item=>{
           
    //    return item
    //   }).sort((a,b)=>{
    //       return a.areaId-b.areaId
    //     })   
        this.itemTitle = this.message[0].name;
        this.meUrl = this.message[0].url;
        this.$emit("wrid", this.meUrl);
      });
    },

    handleCommand(command) {
      this.id = this.$store.state.project.currentProject.projectId;
      this.itemTitle = this.message[command].name;
      this.meUrl = this.message[command].url;
      this.$emit("wrid", this.meUrl);
    },
  },
};
</script>
<style scoped lang="less"> 
/deep/.is-current>.el-tree-node__content{        
  background: #F1F1F1 !important;  
   color:#0D94FF;   
  }
/deep/.el-tree-node__children .el-tree-node__content{
  height: 46rem;
  .el-tree-node__label{
    font-size: 16rem;
  }
}
.custom-tree-node{
  font-size: 16rem;
  img{
    position: absolute;
    right: 10px;
  }
    
}

/deep/.el-tree-node__content{
    height: 56rem;
    // background: #F1F1F1;
    .el-tree-node__label{
      padding-left: 15px;
      font-size: 18rem;
       text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
 /deep/ .el-tree-node__expand-icon{
    background: url('../../../assets/img/aright.png') no-repeat;
    display: inline-block;
    position: absolute;
    right: 15px;
    &::before{
      content: none;
    }
  }
  
  /deep/.is-leaf{
    display: none;
    &::before{
      content: none;
    }
  }
  /deep/.is-leaf+span{
    // font-size: 16rem !important;
  }
.active-item{
  background-color: #ecf5ff;
  color: #66b1ff;
}
/deep/.el-popper[x-placement^=bottom]{
  margin-top: 0!important;
}
/deep/.popper__arrow{
  display: none !important;
}
/deep/.el-dropdown-menu__item{
  line-height: 42px;
}
.tag{
  font-size: 18px;
  img{
    width: 26px;
    vertical-align: middle;
    margin-right: 10rem;
  }
}
.monitoringall {
  position: relative;
  padding: 30rem;
  // width: 280rem !important;
  // max-height: 400rem !important;
}
::v-deep .el-dropdown-link:focus {
  outline: none;
}
.el-dropdown-link {
  // width: 500rem;
  text-align: center;
  width: 160px;
  height: 56px;
  line-height: 56px;
  background: #FFFFFF;
  border-radius: 4px;
  display:inline-block;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  // position: absolute;
  // color: #ffffff;
  font-size: 18rem;
  cursor: pointer;
  // left: 30rem;
  // top: 10rem;
}
.el-dropdown-menu {
  margin-top: 0!important;
  padding: 0;
  // width: 290rem !important;
  // left: 16% !important;
  // top: 13% !important;
}
.popper__arrow {
  margin-left: 0 !important;
}
#inp {
  width: 248rem;
  height: 32rem;
  background: rgba(252, 250, 250, 0.15);
  border: 1rem solid rgba(0, 0, 0, 0.15);
  border-radius: 16rem;
  margin-left: 16rem;
  margin-bottom: 16rem;
  padding: 5rem 18rem 0rem 15rem;
  display: flex;
  justify-content: space-between;
  #div-inp {
    background: rgba(252, 250, 250, 0.15);
    color: #999999;
    .w(120);
    font-size: 16rem;
    border: none;
    outline: none;
  }
}

#sousuo {
  .w(18);
  .h(18);
  margin-left: -10rem;
}
.el-icon-search {
  font-size: 18rem;
}
.NoShow {
  position: absolute;
  height: 24rem;
  color: gray;
  font-size: 16rem;
  text-align: center;
  top: 80rem;
  left: 0;
  right: 0;
  margin: auto;
}

.hodern {
  height: 300rem !important;
  max-height: 300rem;
  width: 260rem;
  overflow-y: scroll;
  overflow-x:hidden ;
  text-overflow: ellipsis;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  p{
    overflow-x:hidden ;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.hodern::-webkit-scrollbar {
  width: 8rem;
  height: 72rem;
  background: #fff;
}
div::-webkit-scrollbar-track {
  width: 8rem;
  height: 72rem;
  background: #fff;
  border-radius: 4rem;
}
div::-webkit-scrollbar-thumb {
  width: 8rem;
  height: 72rem;
  background: #bfbfbf;
  border-radius: 10rem;
}
</style>